import { FtueVideo } from '../../../api/core'
import { useGetGameList } from '../../game/hooks/gameHooks'

export const useGetFtueGames = (videos?: FtueVideo[]) => {
  const gameIds = videos?.map(({ gameId }) => gameId) || []
  const include = 'name,artist,icons,conventionalSubgenre,conventionalSubgenreId,sdranks,sranks'
  return useGetGameList({ gameIds, include }, { skip: !videos })
}
